import { findTeamKit } from "../../services/TeamKitService.js";

export function getGameTemplate(game) {
  if (!game.odd) {
    return "";
  }
  return `<div class="singleGameContent">
                 <a class="singleTeamNames" href="#/Match/${
                   game.id
                 }" data-id="${game.id}">
                     <div class="singleDateColumn">
                        <span>${game.game_time.split(":")[0]}:${
    game.game_time.split(":")[1]
  }</span>
                        <span class="numberofmarkets">${
                          game.count_options
                        } ></span>
                     </div>
                     <div class="singleDetailsColumn">
                       <div class="singleTeamRowLabel">
                         <img class="ml-TeamKit_SVG" alt="${
                           game.home_team
                         }" src="${findTeamKit(
    game.home_team
  ) || "img/teams/NoKit.svg?v=2"}" lazy onerror="this.onerror=null;this.src='img/teams/NoKit.svg?v=2'" width="16" height="16" />
                         <span class="singleHomeName">${game.home_team}</span>
                         <span class="gameSingleHomeScore"></span>
                       </div>
                       <div class="singleTeamRowLabel">
                         <img class="ml-TeamKit_SVG" alt="${
                           game.away_team
                         }" src="${findTeamKit(
    game.away_team
  ) || "img/teams/NoKit.svg?v=2"}" lazy onerror="this.onerror=null;this.src='img/teams/NoKit.svg?v=2'" width="16" height="16" />
                         <span class="singleAwayName">${game.away_team}</span>
                         <span class="gameSingleAwayScore"></span>
                       </div>
                     </div>
                 </a>
                 <div class="singleHomeOdd bettingBtn  ${
                   Math.floor(
                     (parseFloat(game.odd.split(",")[0].split("|")[1]) +
                       Number.EPSILON) *
                       100
                   ) /
                     100 ==
                   1
                     ? "disabledBtn"
                     : ""
                 } ${
    game.odd.split(",").length > 0
      ? game.odd.split(",")[0].split("|")[0]
      : "disabledBtn"
  }" 
                    
                       match-odd="${
                         game.odd.split(",").length > 0
                           ? (
                               Math.floor(
                                 (parseFloat(
                                   game.odd.split(",")[0].split("|")[1]
                                 ) +
                                   Number.EPSILON) *
                                   100
                               ) / 100
                             ).toFixed(2)
                           : ""
                       }" 
                       match-home-name="${game.home_team}" 
                       match-away-name="${game.away_team}" 
                       match-market="Rezultat Final" 
                       match-market-option="1 "
                       coef-id="${
                         game.odd.split(",").length > 0
                           ? game.odd.split(",")[0].split("|")[0]
                           : ""
                       }" 
                       bet-id="${
                         game.odd.split(",").length > 0
                           ? game.odd.split(",")[0].split("|")[0]
                           : ""
                       }" 
                       game-id="${game.id}"
                    >
                    ${
                      game.odd.split(",").length > 0
                        ? (
                            Math.floor(
                              (parseFloat(
                                game.odd.split(",")[0].split("|")[1]
                              ) +
                                Number.EPSILON) *
                                100
                            ) / 100
                          ).toFixed(2)
                        : ""
                    }
                 </div>
                 <div class="singleDrawOdd bettingBtn  ${
                   Math.floor(
                     (parseFloat(game.odd.split(",")[1].split("|")[1]) +
                       Number.EPSILON) *
                       100
                   ) /
                     100 ==
                   1
                     ? "disabledBtn"
                     : ""
                 } ${
    game.odd.split(",").length > 1
      ? game.odd.split(",")[1].split("|")[0]
      : "disabledBtn"
  }" 
                 
                    match-odd="${
                      game.odd.split(",").length > 1
                        ? (
                            Math.floor(
                              (parseFloat(
                                game.odd.split(",")[1].split("|")[1]
                              ) +
                                Number.EPSILON) *
                                100
                            ) / 100
                          ).toFixed(2)
                        : ""
                    }" 
                    match-home-name="${game.home_team}" 
                    match-away-name="${game.away_team}" 
                    match-market="Rezultat Final" 
                    match-market-option="X "
                    coef-id="${
                      game.odd.split(",").length > 1
                        ? game.odd.split(",")[1].split("|")[0]
                        : ""
                    }" 
                    bet-id="${
                      game.odd.split(",").length > 1
                        ? game.odd.split(",")[1].split("|")[0]
                        : ""
                    }" 
                    game-id="${game.id}"
                    
                    >
                     ${
                       game.odd.split(",").length > 1
                         ? (
                             Math.floor(
                               (parseFloat(
                                 game.odd.split(",")[1].split("|")[1]
                               ) +
                                 Number.EPSILON) *
                                 100
                             ) / 100
                           ).toFixed(2)
                         : ""
                     }
                 </div>
                 ${
                   game.odd.split(",").length == 3 &&
                   game.odd.split(",")[2].split("|").length > 1
                     ? `    <div class="singleAwayOdd bettingBtn  ${
                         Math.floor(
                           (parseFloat(game.odd.split(",")[2].split("|")[1]) +
                             Number.EPSILON) *
                             100
                         ) /
                           100 ==
                         1
                           ? "disabledBtn"
                           : ""
                       } ${
                         game.odd.split(",").length > 2
                           ? game.odd.split(",")[2].split("|")[0]
                           : "disabledBtn"
                       }" 
                 
                 match-odd="${
                   game.odd.split(",").length > 2
                     ? (
                         Math.floor(
                           (parseFloat(game.odd.split(",")[2].split("|")[1]) +
                             Number.EPSILON) *
                             100
                         ) / 100
                       ).toFixed(2)
                     : ""
                 }" 
                 match-home-name="${game.home_team}" 
                 match-away-name="${game.away_team}" 
                 match-market-option="2 "
                 match-market="Rezultat Final" 
                 coef-id="${
                   game.odd.split(",").length > 2
                     ? game.odd.split(",")[2].split("|")[0]
                     : ""
                 }" 
                 bet-id="${
                   game.odd.split(",").length > 2
                     ? game.odd.split(",")[2].split("|")[0]
                     : ""
                 }" 
                 game-id="${game.id}"
              >
              ${
                game.odd.split(",").length > 2
                  ? (
                      Math.floor(
                        (parseFloat(game.odd.split(",")[2].split("|")[1]) +
                          Number.EPSILON) *
                          100
                      ) / 100
                    ).toFixed(2)
                  : ""
              }
              </div>`
                     : ``
                 }
             
               </div>`;
}
